import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/servizi", label: "Servizi" },
  { to: "/academy", label: "Lux Academy" },
  { to: "/tema-natale", label: "Tema Natale" },
  { to: "/eventi", label: "Eventi" },
  { to: "/blog", label: "Blog" },
  { to: "/fondatore", label: "Fondatore" },
  { to: "/contatti", label: "Contatti" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const loc = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-[100]">
      <div className="glass">
        <nav className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between" data-testid="navbar">
          <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
            <span className="font-display text-xl tracking-[0.2em] text-[#2A1F14]">LUX</span>
            <span className="w-1 h-1 rounded-full bg-gold" />
            <span className="font-display text-xl tracking-[0.2em] text-gold">AETERNA</span>
          </Link>

          <div className="hidden lg:flex items-center gap-8">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.to.slice(1)}`}
                className={`text-sm tracking-wide link-underline transition-colors duration-300 ${loc.pathname.startsWith(l.to) ? "text-gold" : "text-[#2A1F14]/70 hover:text-[#2A1F14]"}`}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to={user ? (user.role === "admin" ? "/admin" : "/area-studente") : "/accedi"}
              data-testid="nav-account"
              className="text-sm tracking-wide px-5 py-2 rounded-full border border-gold/40 text-gold hover:bg-gold hover:text-black transition-colors duration-300"
            >
              {user ? (user.role === "admin" ? "Dashboard" : "Area Studente") : "Accedi"}
            </Link>
          </div>

          <button className="lg:hidden text-[#2A1F14]" onClick={() => setOpen(true)} data-testid="nav-menu-open" aria-label="Apri menu">
            <Menu size={24} />
          </button>
        </nav>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="fixed inset-0 z-[110] bg-[#F7EFE0] lg:hidden constellation"
            data-testid="mobile-menu"
          >
            <div className="flex justify-between items-center px-6 h-16 border-b border-[#2A1F14]/10">
              <span className="font-display text-xl tracking-[0.2em] text-gold">LUX AETERNA</span>
              <button onClick={() => setOpen(false)} data-testid="nav-menu-close" aria-label="Chiudi menu"><X className="text-[#2A1F14]" /></button>
            </div>
            <div className="flex flex-col px-6 py-10 gap-6">
              {LINKS.map((l) => (
                <Link key={l.to} to={l.to} onClick={() => setOpen(false)} data-testid={`mobile-nav-${l.to.slice(1)}`} className="font-display text-3xl text-[#2A1F14]/90 hover:text-gold transition-colors">
                  {l.label}
                </Link>
              ))}
              <Link to={user ? (user.role === "admin" ? "/admin" : "/area-studente") : "/accedi"} onClick={() => setOpen(false)} data-testid="mobile-nav-account" className="mt-4 text-gold text-lg">
                {user ? (user.role === "admin" ? "Dashboard →" : "Area Studente →") : "Accedi →"}
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
